export const changeSeasonReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_season":
      return action.payload.season;
    default:
      return state;
  }
};
